
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ipElb2kaFXh597uffrxpf9tuaTMtJQ6nlTro2n3p0g_nIMeta } from "/build_dir/app/pages/ip.vue?macro=true";
import { default as colorGRTwSJMBgTwpMrlKDL6SDBoH4ACQ__45aweaIxn6aBAgkMeta } from "/build_dir/app/pages/color.vue?macro=true";
import { default as indexphKNfTMKaRvaV7ZiGZLCIK3BT5wz82anMa2wMb8joLoMeta } from "/build_dir/app/pages/index.vue?macro=true";
import { default as rimurutslxDBnTsxaQnwMhEYC7D1N5i4rrx7o_45uYesNcA852UMeta } from "/build_dir/app/pages/rimuru.vue?macro=true";
import { default as downloadGNQn_TWojgV1mCXE9JBMUCIBfrDK9DIGKe9t_45tDmmKkMeta } from "/build_dir/app/pages/download.vue?macro=true";
import { default as _91id_93s_lnb2DFifrjm8K6m4AeQKqz6ihNka2rI0DpU01XgqMMeta } from "/build_dir/app/pages/feed/[id].vue?macro=true";
import { default as _91id_93KKGFpCdeI9qNwDiSfzacrIZqSrqkpm3cCCaioMW28NEMeta } from "/build_dir/app/pages/embed/[id].vue?macro=true";
import { default as badXMsSBUhHxiSZmKK5jtp1ZTthB5i03AR3PdI8buGJg_45MMeta } from "/build_dir/app/pages/report/bad.vue?macro=true";
import { default as _91id_9304tYTn22L_ZNYBJF1vOl5XZfnelWMpWVYDL4yxLiWtgMeta } from "/build_dir/app/pages/video/[id].vue?macro=true";
import { default as feedtnRN_452qea5u4OXIFTs2h4XExOD306R8UCHImhH2fJzEMeta } from "/build_dir/app/pages/create/feed.vue?macro=true";
import { default as signjjPxX_45o_yOcoGrXCqvF_45mPdbmbB4u_K7cf0fgkpjdMMMeta } from "/build_dir/app/pages/member/sign.vue?macro=true";
import { default as teenH75KuEMJcSEzDXrrMmGNSBqYvLg7VoIaik7UxS7TNHgMeta } from "/build_dir/app/pages/report/teen.vue?macro=true";
import { default as _91id_93_45VztaFqBoPO3flLAb_9IqzM8y4N_45AMWRCXIzRtZVmPMMeta } from "/build_dir/app/pages/article/[id].vue?macro=true";
import { default as indextxLGgpQVlCOOd_45DbE2Xs6rFeuG_45O1iiPwf6TFT5HlvgMeta } from "/build_dir/app/pages/create/index.vue?macro=true";
import { default as videoRUPZi2zacYZoQCxj4LkVnd0iBBarIR_2ycZROLlFRqgMeta } from "/build_dir/app/pages/create/video.vue?macro=true";
import { default as likeD2wu94DHetPARSmbVmrFWUK_45L_45eh1gNCrB_pjoC7iZgMeta } from "/build_dir/app/pages/message/like.vue?macro=true";
import { default as indexta3wSVwBPX9ZP6d9NKqQefXfcu5UsMEo5VabxZCA6yAMeta } from "/build_dir/app/pages/search/index.vue?macro=true";
import { default as reply9cBT3qpQzoOPOCwT_qiLzE1cNRv3YN88r7ETc_45OPNpIMeta } from "/build_dir/app/pages/message/reply.vue?macro=true";
import { default as _91cid_93hreVMg1mV6Nzu0TW_mDH_Igk_a2BddARs91m1PRe1H4Meta } from "/build_dir/app/pages/category/[cid].vue?macro=true";
import { default as article3cm0f7Hj2ZmS3xo_45mHsplUMiR4ptl_45MAV_9ffNLtlM8Meta } from "/build_dir/app/pages/create/article.vue?macro=true";
import { default as danmaku_45MX0Rr3Oa7bI7gP38So68gjEXZ2hVD_GY4VxdfcTKkQMeta } from "/build_dir/app/pages/create/danmaku.vue?macro=true";
import { default as historyRJF84g5m1MLsiQLiY0oi8H6ujyse_45_Wstvc9AWhTAEgMeta } from "/build_dir/app/pages/member/history.vue?macro=true";
import { default as systemnoogR2zEVstPkf0_45Ffs8mHHUhZFBXb0gbJ_8cEX7vcUMeta } from "/build_dir/app/pages/message/system.vue?macro=true";
import { default as _91id_93YuN3E6zAxnfLLivtVdoHMQ6NGwuyVnrmYRC92gdZ_54Meta } from "/build_dir/app/pages/collection/[id].vue?macro=true";
import { default as activity47yVt3V0QDUakH9HVzAzaRF4OwpK7OPlyqhtxRC9BB0Meta } from "/build_dir/app/pages/create/activity.vue?macro=true";
import { default as mentionB8KPUGihlurrMfWxUxwzL5taIehq_NdUs331gVicbdIMeta } from "/build_dir/app/pages/message/mention.vue?macro=true";
import { default as whisperkDJA0T27OL0eJpNZcayw07HC_45wbx5g9c6LWe7M2pEccMeta } from "/build_dir/app/pages/message/whisper.vue?macro=true";
import { default as globalEXNb40P9bAhw0D9dthUWCH0dTWdnr6brmNqafxsjC8UMeta } from "/build_dir/app/pages/timeline/global.vue?macro=true";
import { default as newest_45QKhRmTljcIt2cjUt54tgTFTRajQwCQ0hzJytUY1WbIMeta } from "/build_dir/app/pages/timeline/newest.vue?macro=true";
import { default as videoFile47miFPuIlegGgO256j7wFDZV5sYKtD3Kcf9Nfi_WXQ4Meta } from "/build_dir/app/pages/create/videoFile.vue?macro=true";
import { default as contacto3v7MDQ11wuwPpYjMCgE_whw_E92J7erxuFMqnzmAOcMeta } from "/build_dir/app/pages/customer/contact.vue?macro=true";
import { default as fansjW6StDFZFIomWh050xwBUxDK_BZmv9sCKH3_qePmcVoMeta } from "/build_dir/app/pages/member/[id]/fans.vue?macro=true";
import { default as itemJkvDGCQjeEn_eFAWTbd8qj615BucA5YRHKgYAW0vbIYMeta } from "/build_dir/app/pages/member/[id]/item.vue?macro=true";
import { default as safebzkpvuQ9sr66QbjFYSw_45yCEKThkKIagMre0EWn5mMKAMeta } from "/build_dir/app/pages/member/[id]/safe.vue?macro=true";
import { default as index7Wg1231nMGQsbKisC2TaoPLAHzFyisXDuaGnaYPHu0kMeta } from "/build_dir/app/pages/tag/[name]/index.vue?macro=true";
import { default as videoaE_45m1aHbtdDxWVUvWB7CXxdUz3lGNDiDh3wD7TF7kiMMeta } from "/build_dir/app/pages/tag/[name]/video.vue?macro=true";
import { default as contributeU5a93GFBhlTTSYX_9u2gWWybNUkhNLqGCX5r7eCBejgMeta } from "/build_dir/app/pages/create/contribute.vue?macro=true";
import { default as badgeQ3s0CHmnzAtJT4qzvYcBQUq7x__WQI4GhgQIsBnR3qUMeta } from "/build_dir/app/pages/member/[id]/badge.vue?macro=true";
import { default as indexphSU7zf9ZMx9gLzvwSko_45ImLo5Nye1NnhRUwo0Gb97cMeta } from "/build_dir/app/pages/member/[id]/index.vue?macro=true";
import { default as plagiarismjWCx9IMyKMGt6qZ3cM3v0rooXssHZoFdC48K_VmQIbIMeta } from "/build_dir/app/pages/report/plagiarism.vue?macro=true";
import { default as followaYpG2Ia15J5mdh5LxkVA7ubEgP3IAKDUEI5YFieKh_45oMeta } from "/build_dir/app/pages/member/[id]/follow.vue?macro=true";
import { default as article_452jVUgmDlW1uqs_eG53eXftXBegHFuKJizh6AEQB4r8Meta } from "/build_dir/app/pages/tag/[name]/article.vue?macro=true";
import { default as premiumr2DWJAhM1CUf476VbmF0CXh_45r0tXDLUf8ksJPbWtTCoMeta } from "/build_dir/app/pages/member/[id]/premium.vue?macro=true";
import { default as profileBHYtk3KnV9viQlj3UI7VWRRJRbb_45idoZMUGk5w8Q_45qEMeta } from "/build_dir/app/pages/member/[id]/profile.vue?macro=true";
import { default as customeras6V97uCLxifsAfcHhxlppNwv0YjZPGNJv7nDWv_45R5UMeta } from "/build_dir/app/pages/member/[id]/customer.vue?macro=true";
import { default as favorite_45cKBz38GaJIYhERREhqToAk_45p3hK_1463H4gS7eIiG4Meta } from "/build_dir/app/pages/member/[id]/favorite.vue?macro=true";
import { default as _91id_93a7tJLD16NBo2RMtWdBMsI_prav6pyaIZO3xDjiUlWisMeta } from "/build_dir/app/pages/timeline/follow/[id].vue?macro=true";
import { default as blacklistwqSeGNq29FFG5a_1wJqlv9uGXPMD_b8atjqzTVvrFxgMeta } from "/build_dir/app/pages/member/[id]/blacklist.vue?macro=true";
import { default as videoListTuz7tYnlhrexWHwqHgksiI9VgA2fgpGOefwWksvkYyAMeta } from "/build_dir/app/pages/member/[id]/videoList.vue?macro=true";
import { default as indexAL9MzI1WDRstkgT2_45t58juto6Z7wjr8aSBM__450VwiScMeta } from "/build_dir/app/pages/timeline/follow/index.vue?macro=true";
import { default as articleList_45igiLvroU_45lhFXoplJRVLy1CC9G37o9SVELfMkbVDCYMeta } from "/build_dir/app/pages/member/[id]/articleList.vue?macro=true";
import { default as emailTJEc3O_3bTOoy_MgqR5Y_6kAJxE8Ck65_45Y2X8raOqZ8Meta } from "/build_dir/app/pages/settings/security/email.vue?macro=true";
import { default as phonejzba_45hUDe0MYU5J6o3faPmObL0G6UAS9gT10E1axp24Meta } from "/build_dir/app/pages/settings/security/phone.vue?macro=true";
import { default as deleteQ99c3R_TLw4SIcRGGvt_ry692nLUoPs46r_45UhK4f3ZIMeta } from "/build_dir/app/pages/settings/security/delete.vue?macro=true";
import { default as accessibilityBL5IGfR6wAozD1rLz0xCPL9TustJQgV5nZATceS1g3AMeta } from "/build_dir/app/pages/member/[id]/accessibility.vue?macro=true";
import { default as deleteAccount0ayh6dM46ls8CNTobR2NnZxMO_QMvukpO6hc7apXPFoMeta } from "/build_dir/app/pages/member/[id]/deleteAccount.vue?macro=true";
import { default as passwordgQDH_45YmvRXQm7u2ceRfwAy66RzTSBoa69H5hvS0RnTIMeta } from "/build_dir/app/pages/settings/security/password.vue?macro=true";
import { default as resetPasswordJLXo1_457OFY7NfMB3CBB7STE5xzU9gqLqtu53ILreIWcMeta } from "/build_dir/app/pages/settings/security/resetPassword.vue?macro=true";
export default [
  {
    name: "ip",
    path: "/ip",
    component: () => import("/build_dir/app/pages/ip.vue")
  },
  {
    name: "color",
    path: "/color",
    meta: colorGRTwSJMBgTwpMrlKDL6SDBoH4ACQ__45aweaIxn6aBAgkMeta || {},
    component: () => import("/build_dir/app/pages/color.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexphKNfTMKaRvaV7ZiGZLCIK3BT5wz82anMa2wMb8joLoMeta || {},
    component: () => import("/build_dir/app/pages/index.vue")
  },
  {
    name: "rimuru",
    path: "/rimuru",
    meta: rimurutslxDBnTsxaQnwMhEYC7D1N5i4rrx7o_45uYesNcA852UMeta || {},
    component: () => import("/build_dir/app/pages/rimuru.vue")
  },
  {
    name: "download",
    path: "/download",
    meta: downloadGNQn_TWojgV1mCXE9JBMUCIBfrDK9DIGKe9t_45tDmmKkMeta || {},
    component: () => import("/build_dir/app/pages/download.vue")
  },
  {
    name: "feed-id",
    path: "/feed/:id()",
    meta: {"middleware":"feed"},
    component: () => import("/build_dir/app/pages/feed/[id].vue")
  },
  {
    name: "embed-id",
    path: "/embed/:id()",
    meta: _91id_93KKGFpCdeI9qNwDiSfzacrIZqSrqkpm3cCCaioMW28NEMeta || {},
    component: () => import("/build_dir/app/pages/embed/[id].vue")
  },
  {
    name: "report-bad",
    path: "/report/bad",
    meta: badXMsSBUhHxiSZmKK5jtp1ZTthB5i03AR3PdI8buGJg_45MMeta || {},
    component: () => import("/build_dir/app/pages/report/bad.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    meta: _91id_9304tYTn22L_ZNYBJF1vOl5XZfnelWMpWVYDL4yxLiWtgMeta || {},
    component: () => import("/build_dir/app/pages/video/[id].vue")
  },
  {
    name: "create-feed",
    path: "/create/feed",
    meta: { ...(feedtnRN_452qea5u4OXIFTs2h4XExOD306R8UCHImhH2fJzEMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/create/feed.vue")
  },
  {
    name: "member-sign",
    path: "/member/sign",
    component: () => import("/build_dir/app/pages/member/sign.vue")
  },
  {
    name: "report-teen",
    path: "/report/teen",
    meta: teenH75KuEMJcSEzDXrrMmGNSBqYvLg7VoIaik7UxS7TNHgMeta || {},
    component: () => import("/build_dir/app/pages/report/teen.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    meta: _91id_93_45VztaFqBoPO3flLAb_9IqzM8y4N_45AMWRCXIzRtZVmPMMeta || {},
    component: () => import("/build_dir/app/pages/article/[id].vue")
  },
  {
    name: "create",
    path: "/create",
    meta: { ...(indextxLGgpQVlCOOd_45DbE2Xs6rFeuG_45O1iiPwf6TFT5HlvgMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/create/index.vue")
  },
  {
    name: "create-video",
    path: "/create/video",
    meta: { ...(videoRUPZi2zacYZoQCxj4LkVnd0iBBarIR_2ycZROLlFRqgMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/create/video.vue")
  },
  {
    name: "message-like",
    path: "/message/like",
    meta: likeD2wu94DHetPARSmbVmrFWUK_45L_45eh1gNCrB_pjoC7iZgMeta || {},
    component: () => import("/build_dir/app/pages/message/like.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexta3wSVwBPX9ZP6d9NKqQefXfcu5UsMEo5VabxZCA6yAMeta || {},
    component: () => import("/build_dir/app/pages/search/index.vue")
  },
  {
    name: "message-reply",
    path: "/message/reply",
    meta: reply9cBT3qpQzoOPOCwT_qiLzE1cNRv3YN88r7ETc_45OPNpIMeta || {},
    component: () => import("/build_dir/app/pages/message/reply.vue")
  },
  {
    name: "category-cid",
    path: "/category/:cid()",
    meta: _91cid_93hreVMg1mV6Nzu0TW_mDH_Igk_a2BddARs91m1PRe1H4Meta || {},
    component: () => import("/build_dir/app/pages/category/[cid].vue")
  },
  {
    name: "create-article",
    path: "/create/article",
    meta: { ...(article3cm0f7Hj2ZmS3xo_45mHsplUMiR4ptl_45MAV_9ffNLtlM8Meta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/create/article.vue")
  },
  {
    name: "create-danmaku",
    path: "/create/danmaku",
    meta: { ...(danmaku_45MX0Rr3Oa7bI7gP38So68gjEXZ2hVD_GY4VxdfcTKkQMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/create/danmaku.vue")
  },
  {
    name: "member-history",
    path: "/member/history",
    meta: historyRJF84g5m1MLsiQLiY0oi8H6ujyse_45_Wstvc9AWhTAEgMeta || {},
    component: () => import("/build_dir/app/pages/member/history.vue")
  },
  {
    name: "message-system",
    path: "/message/system",
    meta: systemnoogR2zEVstPkf0_45Ffs8mHHUhZFBXb0gbJ_8cEX7vcUMeta || {},
    component: () => import("/build_dir/app/pages/message/system.vue")
  },
  {
    name: "collection-id",
    path: "/collection/:id()",
    meta: _91id_93YuN3E6zAxnfLLivtVdoHMQ6NGwuyVnrmYRC92gdZ_54Meta || {},
    component: () => import("/build_dir/app/pages/collection/[id].vue")
  },
  {
    name: "create-activity",
    path: "/create/activity",
    meta: { ...(activity47yVt3V0QDUakH9HVzAzaRF4OwpK7OPlyqhtxRC9BB0Meta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/create/activity.vue")
  },
  {
    name: "message-mention",
    path: "/message/mention",
    meta: mentionB8KPUGihlurrMfWxUxwzL5taIehq_NdUs331gVicbdIMeta || {},
    component: () => import("/build_dir/app/pages/message/mention.vue")
  },
  {
    name: "message-whisper",
    path: "/message/whisper",
    meta: { ...(whisperkDJA0T27OL0eJpNZcayw07HC_45wbx5g9c6LWe7M2pEccMeta || {}), ...{"middleware":"login"} },
    component: () => import("/build_dir/app/pages/message/whisper.vue")
  },
  {
    name: "timeline-global",
    path: "/timeline/global",
    meta: globalEXNb40P9bAhw0D9dthUWCH0dTWdnr6brmNqafxsjC8UMeta || {},
    component: () => import("/build_dir/app/pages/timeline/global.vue")
  },
  {
    name: "timeline-newest",
    path: "/timeline/newest",
    meta: newest_45QKhRmTljcIt2cjUt54tgTFTRajQwCQ0hzJytUY1WbIMeta || {},
    component: () => import("/build_dir/app/pages/timeline/newest.vue")
  },
  {
    name: "create-videoFile",
    path: "/create/videoFile",
    meta: { ...(videoFile47miFPuIlegGgO256j7wFDZV5sYKtD3Kcf9Nfi_WXQ4Meta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/create/videoFile.vue")
  },
  {
    name: "customer-contact",
    path: "/customer/contact",
    meta: contacto3v7MDQ11wuwPpYjMCgE_whw_E92J7erxuFMqnzmAOcMeta || {},
    component: () => import("/build_dir/app/pages/customer/contact.vue")
  },
  {
    name: "member-id-fans",
    path: "/member/:id()/fans",
    meta: fansjW6StDFZFIomWh050xwBUxDK_BZmv9sCKH3_qePmcVoMeta || {},
    component: () => import("/build_dir/app/pages/member/[id]/fans.vue")
  },
  {
    name: "member-id-item",
    path: "/member/:id()/item",
    meta: { ...(itemJkvDGCQjeEn_eFAWTbd8qj615BucA5YRHKgYAW0vbIYMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/item.vue")
  },
  {
    name: "member-id-safe",
    path: "/member/:id()/safe",
    meta: { ...(safebzkpvuQ9sr66QbjFYSw_45yCEKThkKIagMre0EWn5mMKAMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/safe.vue")
  },
  {
    name: "tag-name",
    path: "/tag/:name()",
    meta: index7Wg1231nMGQsbKisC2TaoPLAHzFyisXDuaGnaYPHu0kMeta || {},
    component: () => import("/build_dir/app/pages/tag/[name]/index.vue")
  },
  {
    name: "tag-name-video",
    path: "/tag/:name()/video",
    meta: videoaE_45m1aHbtdDxWVUvWB7CXxdUz3lGNDiDh3wD7TF7kiMMeta || {},
    component: () => import("/build_dir/app/pages/tag/[name]/video.vue")
  },
  {
    name: "create-contribute",
    path: "/create/contribute",
    meta: { ...(contributeU5a93GFBhlTTSYX_9u2gWWybNUkhNLqGCX5r7eCBejgMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/create/contribute.vue")
  },
  {
    name: "member-id-badge",
    path: "/member/:id()/badge",
    meta: { ...(badgeQ3s0CHmnzAtJT4qzvYcBQUq7x__WQI4GhgQIsBnR3qUMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/badge.vue")
  },
  {
    name: "member-id",
    path: "/member/:id()",
    meta: indexphSU7zf9ZMx9gLzvwSko_45ImLo5Nye1NnhRUwo0Gb97cMeta || {},
    component: () => import("/build_dir/app/pages/member/[id]/index.vue")
  },
  {
    name: "report-plagiarism",
    path: "/report/plagiarism",
    meta: plagiarismjWCx9IMyKMGt6qZ3cM3v0rooXssHZoFdC48K_VmQIbIMeta || {},
    component: () => import("/build_dir/app/pages/report/plagiarism.vue")
  },
  {
    name: "member-id-follow",
    path: "/member/:id()/follow",
    meta: followaYpG2Ia15J5mdh5LxkVA7ubEgP3IAKDUEI5YFieKh_45oMeta || {},
    component: () => import("/build_dir/app/pages/member/[id]/follow.vue")
  },
  {
    name: "tag-name-article",
    path: "/tag/:name()/article",
    meta: article_452jVUgmDlW1uqs_eG53eXftXBegHFuKJizh6AEQB4r8Meta || {},
    component: () => import("/build_dir/app/pages/tag/[name]/article.vue")
  },
  {
    name: "member-id-premium",
    path: "/member/:id()/premium",
    meta: { ...(premiumr2DWJAhM1CUf476VbmF0CXh_45r0tXDLUf8ksJPbWtTCoMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/premium.vue")
  },
  {
    name: "member-id-profile",
    path: "/member/:id()/profile",
    meta: { ...(profileBHYtk3KnV9viQlj3UI7VWRRJRbb_45idoZMUGk5w8Q_45qEMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/profile.vue")
  },
  {
    name: "member-id-customer",
    path: "/member/:id()/customer",
    meta: { ...(customeras6V97uCLxifsAfcHhxlppNwv0YjZPGNJv7nDWv_45R5UMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/customer.vue")
  },
  {
    name: "member-id-favorite",
    path: "/member/:id()/favorite",
    meta: favorite_45cKBz38GaJIYhERREhqToAk_45p3hK_1463H4gS7eIiG4Meta || {},
    component: () => import("/build_dir/app/pages/member/[id]/favorite.vue")
  },
  {
    name: "timeline-follow-id",
    path: "/timeline/follow/:id()",
    meta: { ...(_91id_93a7tJLD16NBo2RMtWdBMsI_prav6pyaIZO3xDjiUlWisMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/timeline/follow/[id].vue")
  },
  {
    name: "member-id-blacklist",
    path: "/member/:id()/blacklist",
    meta: { ...(blacklistwqSeGNq29FFG5a_1wJqlv9uGXPMD_b8atjqzTVvrFxgMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/blacklist.vue")
  },
  {
    name: "member-id-videoList",
    path: "/member/:id()/videoList",
    meta: videoListTuz7tYnlhrexWHwqHgksiI9VgA2fgpGOefwWksvkYyAMeta || {},
    component: () => import("/build_dir/app/pages/member/[id]/videoList.vue")
  },
  {
    name: "timeline-follow",
    path: "/timeline/follow",
    meta: { ...(indexAL9MzI1WDRstkgT2_45t58juto6Z7wjr8aSBM__450VwiScMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/build_dir/app/pages/timeline/follow/index.vue")
  },
  {
    name: "member-id-articleList",
    path: "/member/:id()/articleList",
    meta: articleList_45igiLvroU_45lhFXoplJRVLy1CC9G37o9SVELfMkbVDCYMeta || {},
    component: () => import("/build_dir/app/pages/member/[id]/articleList.vue")
  },
  {
    name: "settings-security-email",
    path: "/settings/security/email",
    meta: { ...(emailTJEc3O_3bTOoy_MgqR5Y_6kAJxE8Ck65_45Y2X8raOqZ8Meta || {}), ...{"middleware":"login"} },
    component: () => import("/build_dir/app/pages/settings/security/email.vue")
  },
  {
    name: "settings-security-phone",
    path: "/settings/security/phone",
    meta: { ...(phonejzba_45hUDe0MYU5J6o3faPmObL0G6UAS9gT10E1axp24Meta || {}), ...{"middleware":"login"} },
    component: () => import("/build_dir/app/pages/settings/security/phone.vue")
  },
  {
    name: "settings-security-delete",
    path: "/settings/security/delete",
    meta: { ...(deleteQ99c3R_TLw4SIcRGGvt_ry692nLUoPs46r_45UhK4f3ZIMeta || {}), ...{"middleware":"login"} },
    component: () => import("/build_dir/app/pages/settings/security/delete.vue")
  },
  {
    name: "member-id-accessibility",
    path: "/member/:id()/accessibility",
    meta: { ...(accessibilityBL5IGfR6wAozD1rLz0xCPL9TustJQgV5nZATceS1g3AMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/accessibility.vue")
  },
  {
    name: "member-id-deleteAccount",
    path: "/member/:id()/deleteAccount",
    meta: { ...(deleteAccount0ayh6dM46ls8CNTobR2NnZxMO_QMvukpO6hc7apXPFoMeta || {}), ...{"middleware":"self"} },
    component: () => import("/build_dir/app/pages/member/[id]/deleteAccount.vue")
  },
  {
    name: "settings-security-password",
    path: "/settings/security/password",
    meta: { ...(passwordgQDH_45YmvRXQm7u2ceRfwAy66RzTSBoa69H5hvS0RnTIMeta || {}), ...{"middleware":"login"} },
    component: () => import("/build_dir/app/pages/settings/security/password.vue")
  },
  {
    name: "settings-security-resetPassword",
    path: "/settings/security/resetPassword",
    meta: resetPasswordJLXo1_457OFY7NfMB3CBB7STE5xzU9gqLqtu53ILreIWcMeta || {},
    component: () => import("/build_dir/app/pages/settings/security/resetPassword.vue")
  }
]